import Vue from 'vue'
import VueI18n from 'vue-i18n'
import EnLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import jaLocale from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
Vue.use(VueI18n)

const DEFAULT_LANG = 'zh'
const LOCALE_KEY = 'en'
const JAPANESE = 'jp'

const locales = {
  zh: { ...require('./zh.json'), ...zhLocale },
  en: { ...require('./en.json'), ...EnLocale },
  jp: { ...require('./jp.json'), ...jaLocale }
}
const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales
})
export const setup = lang => {
  if (lang === undefined) {
    lang = window.sessionStorage.getItem('Language')
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG
      locale.use(zhLocale)
      window.sessionStorage.setItem('Language', lang)
    }
  } else if (lang === 0) {
    if (lang !== window.sessionStorage.getItem('Language')) {
      lang = DEFAULT_LANG
      locale.use(zhLocale)
      window.sessionStorage.setItem('Language', lang)
    }
  } else if (lang === 1) {
    if (lang !== window.sessionStorage.getItem('Language')) {
      lang = LOCALE_KEY
      locale.use(EnLocale)
      window.sessionStorage.setItem('Language', lang)
    }
  } else if (lang === 2) {
    if (lang !== window.sessionStorage.getItem('Language')) {
      lang = JAPANESE
      locale.use(jaLocale)
      window.sessionStorage.setItem('Language', lang)
    }
  }
  i18n.locale = lang
}

setup()
window.i18n = i18n

export default i18n
